// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__ijQZp","notes":"Notes_notes__28pgW","note":"Notes_note__2glSi","markdown":"Notes_markdown__2Dt-C"};